$(document).ready(function() {
	if( !document.querySelector('.C0011') ) return false;

	var timer;
	var tab_sticky = function() {
		var p = tab_sticky.prototype;

		// DOM variable
		// LGEUS-12198
		var $this = $(".C0011"),
			$btnDropMenu = $this.find(".btn-drop-menu-mob"),
			$tabMenuList = $this.find(".tab-menu-belt"),
			$dimedLayer = $this.find(".back-layer"),
			//PJTUSPDPUX-1 START
			$linkers = $tabMenuList.find('.linker:not(.wtb-external-link)'),
			$tabMenu = $tabMenuList.find('.tab-menu'),
			$tabContainers = $linkers.map(function(){ return $.find($(this).attr('href'))}),
			//PJTUSPDPUX-1 END
			$templateBase = $this.find('template.extra-menu-template').clone();
		// LGEUS-12198 End

		$this.find('template.extra-menu-template').remove();

		// sticky by page scroll
		var	cutLine = parseInt( $this.closest(".component-wrap").offset().top );

		$(window).on("resize", function(){
			cutLine = parseInt( $this.closest(".component-wrap").offset().top );
			return cutLine;
		});

		// PDPPJT 20200917 tab length 5,6 width
		$($tabMenuList).each(function() {
			if($tabMenu.length==5) {
				$tabMenu.parent().addClass("column-5");
			}else if($tabMenu.length==6){
				$tabMenu.parent().addClass("column-6");
			}
		});

		var im;
		var checkImgNum = 0;
		function checkImgLoad() {
			var cntLoad = 0,
				cntLoaded = 0;
			$('.component').each(function() {
				if(!$(this).hasClass('.C0009')) {
					if($(this).find('.slick-initialized ').length==0) {
						cntLoad = cntLoad + $(this).find('img.lazyloaded').length;
						cntLoaded = cntLoaded + $(this).find('img[data-loaded=true]').length;
					} else {
						cntLoad = cntLoad + parseInt($(this).find('.slick-active').length);
						cntLoaded = cntLoaded + parseInt($(this).find('.slick-active').length);
					}
				}
			});
			checkImgNum ++;
			//console.log(cntLoad, cntLoaded, checkImgNum);
			if((cntLoad <= cntLoaded) || checkImgNum >= 20) { // Maximum of 2 seconds
				return true;
			} else {
				return false;
			}
		}
		function getTargetScrollTop(target) {
			var objTop = $(target).offset().top - 62;
			var hasPadding = ["#pdp_review", "#pdp_spec"];
			if(hasPadding.indexOf(target) >= 0) {
				objTop = objTop - 50;
			}
			if(!$this.hasClass('sticky-active')) {
				objTop = objTop - 62;
			}
			// LGEGMC-648 Start
			if(standardData.pdpStatus == "DISCONTINUED"){
				objTop = objTop + 50;
			}
			// LGEGMC-648 End
			return objTop;
		}
		
		
		$linkers.on('click', function(e){
			e.preventDefault();
			$(this).blur();
			var target = $(this).attr('href');
			var target_id = target.split('#')[1];
			//PJTUSPDPUX-1 START
			if($('.tab-menu-belt').hasClass('open')){
				$('.tab-menu-belt').removeClass('open');
			}
			if($('img.lazyload').length>0) {
				$('img.lazyload').each(function() {
					//lazySizes.loader.unveil($(this).get(0));
					$(this).attr('src', $(this).attr('data-src')).removeClass('lazyload').addClass('lazyloaded');
				});

				im = setInterval(function() {
					var r = checkImgLoad();
					if(r) {
						clearInterval(im);
						setTimeout(function() {
							p.displayEvent(target);
							p.scrollToMenu(target);
							p.setMenuItemActive(target);
							$(target).find('.slick-slider').slick('setPosition');
							//$(window).trigger('resize'); //PJTUSPDP-2 add
						}, 100);
					}
				}, 100);

			} else {
				setTimeout(function() {
					p.displayEvent(target);
					p.scrollToMenu(target);
					p.setMenuItemActive(target);
					$(target).find('.slick-slider').slick('setPosition');
					//$(window).trigger('resize'); //PJTUSPDP-2 add
				}, 100);
			} //PJTUSPDPUX-1 END
			//$(window).addEventListener('resize', function(){}, true);
			//setTimeout(function() {
//				$(window).trigger('resize',function(){$(target).focus();}); //PJTUSPDP-2 add
				//$('.unit-list').slick('setPosition');
				//$(window).trigger('resize');
			//}, 600);
		});
		
		$('body').off('click.extralink').on('click.extralink', '.anchor-btn', function (e) {
			e.preventDefault();
			$(this).blur();
			var target = $(this).attr('href');
			var target_id = target.split('#')[1];
			//PJTUSPDPUX-1 START
			if($('.tab-menu-belt').hasClass('open')){
				$('.tab-menu-belt').removeClass('open');
			}
			if($('img.lazyload').length>0) {
				$('img.lazyload').each(function() {
					//lazySizes.loader.unveil($(this).get(0));
					$(this).attr('src', $(this).attr('data-src')).removeClass('lazyload').addClass('lazyloaded');
				});

				im = setInterval(function() {
					var r = checkImgLoad();
					if(r) {
						clearInterval(im);
						setTimeout(function() {
							p.displayEvent(target);
							p.scrollToMenu(target);
							p.setMenuItemActive(target);
							$(target).find('.slick-slider').slick('setPosition');
							//$(window).trigger('resize'); //PJTUSPDP-2 add
						}, 100);
					}
				}, 100);

			} else {
				setTimeout(function() {
					p.displayEvent(target);
					p.scrollToMenu(target);
					p.setMenuItemActive(target);
					$(target).find('.slick-slider').slick('setPosition');
					//$(window).trigger('resize'); //PJTUSPDP-2 add
				}, 100);
			} //PJTUSPDPUX-1 END
			//$(window).addEventListener('resize', function(){}, true);
			//setTimeout(function() {
//				$(window).trigger('resize',function(){$(target).focus();}); //PJTUSPDP-2 add
				//$('.unit-list').slick('setPosition');
				//$(window).trigger('resize');
			//}, 600);
		});

		p.init = function(){
			//$(window).addEventListener('resize', function(){}, true);
			mql.maxSm.addListener(p.resizeReset);
			this.resizeReset(mql.maxSm);
			/* 20191002 : LGEUS-12249 add */
			//PJTUSPDPUX-1 START
			var target = document.location.hash;
			var orgTarget = "";
			if(target == "#pdp_spec_dimension") {
				target = "#pdp_spec";
				orgTarget= "#pdp_spec_dimension";
			}
			
			if(target !=null && target !="" && $tabContainers.closest(target).length != 0){
				this.displayEvent(target);
				this.setMenuItemActive(target);
				if(orgTarget == "#pdp_spec_dimension") {
					this.newScrollToMenu(target, orgTarget);
				} else {
					this.scrollToMenu(target);
				}				
			} else{
				this.displayEvent($linkers.first()[0].hash);
			}
			/*if(document.location.hash !=null && document.location.hash !=""){
				this.scrollEvent();
			}*/
			//PJTUSPDPUX-1 END
			
			/* //20191002 : LGEUS-12249 add */
			if($('.contents-menu-list').find('a').is('.extra-menu') !== true){
				$('.btn-drop-menu-mob').addClass('not_extra')
			} 
			// contents-menu-list
			this.eventOn();
		};
		
		//PJTUSPDPUX-1 START
		p.displayEvent = function(target){
			if(standardData.pdpStatus !== "DISCONTINUED" || target !=='#overview'){
				$tabContainers.closest(target).show();	
			}
			$tabContainers.not(target).hide();
			
			if(target !== '#pdp_review'){
				$('.C0016').hide();
			}
			else{
				$('.C0016').show();
			}
			
		};
		
		p.setMenuItemActive = function (target){
			var selected = $.grep($linkers, function(elem) {return elem.hash === target;})
			//LGEGMO-5525 add
			$linkers.attr('aria-selected', false);
			$(selected).attr('aria-selected', true);
			//LGEGMO-5525 add
			$(selected).parent().addClass('active').siblings().removeClass('active');
		};
		
		p.scrollToMenu = function(target){
			var menuPos = parseInt($(".C0009").offset().top + $(".C0009").parent().height());
			$('html, body').stop().animate({scrollTop: menuPos}, {duration:500});
			//LGEUS-519 sticky nav 포커스
			$(target).attr('tabindex','0'); 
			$(target).focus();
			//LGEUS-519 sticky nav 포커스 end
		}
		
		p.newScrollToMenu = function(target, orgTarget){
			var menuPos = parseInt($(".C0009").offset().top + $(".C0009").parent().height());
			$('html, body').stop().animate({scrollTop: menuPos}, {duration:500});
			//LGEUS-519 sticky nav 포커스
			$(target).attr('tabindex','0'); 
			$(target).focus();
			
			if(orgTarget == "#pdp_spec_dimension") {
				var offset = $("#hasDimension").offset();
				var top = 0;
				if($("header").hasClass("mobile-device")) {
					top = offset.top;
				} else {
					top = offset.top - 140;
				}
		        $('html, body').animate({scrollTop : top}, 400);
			}
			//LGEUS-519 sticky nav 포커스 end
		}
		//PJTUSPDPUX-1 END

		p.scrollEvent = function(){
			cutLine = parseInt($this.closest(".component-wrap").offset().top );
			
			var scrollPos =  $(window).scrollTop();
			var stiky_condition = scrollPos >= parseInt(cutLine);

			p.scrollPosCheck(stiky_condition);
//			p.scrollAutoFocusing(scrollPos);
			
			//must increase margin of review when there is a sticky nav
			if($this.hasClass("sticky-active")){
				$("#pdp_review").css("margin-top", "80px");
			} 

			// drop reset
			$tabMenuList.removeClass("open");
			//$btnDropMenu.removeClass("open").attr('aria-expanded', false); /* LGEUS-519 삭제 */
			$dimedLayer.removeClass("active");
		};

		p.eventOn = function(){
//			var $menubelt_focusOut = $('.tab-menu-belt li');			
//			$menubelt_focusOut.on("focusout", function(){
//				if($('.tab-menu-belt').hasClass('open')){
//					$('.tab-menu-belt').removeClass('open');
//				}
//			});
			// p.scrollEvent();
			$(window).scroll(function(){
				// clearTimeout( timer );
				// timer = setTimeout( p.scrollEvent, 100 );
				p.scrollEvent();
			});
			
			// mobile event
			$btnDropMenu.on("touch click", function(){
				p.dropMenu( $tabMenuList.hasClass("open") );
				p.dimedException( $this.attr("class").indexOf("sticky-active") < 0 );
			});

			$dimedLayer.on("touch click", function(){
				p.dropMenu( $tabMenuList.hasClass("open") );
			});

			$this.on({
				changeSubModel: function(e, productInfo){
					var _target = e.currentTarget,
						price;

					// price & product name change
					if(productInfo.modelStatusCode=='DISCONTINUED') {
						$(_target).find('.product-selling-price .price').removeClass("active");
						$(_target).find('.product-selling-price .retailer').removeClass("active");
					} else if(productInfo.retailerPricingFlag == "Y") {
						_target.querySelector('.product-selling-price .retailer').innerHTML = productInfo.retailerPricingText;
						$(_target).find('.product-selling-price .price').removeClass("active");
						$(_target).find('.product-selling-price .retailer').addClass("active");
					}else if(productInfo.rPrice && productInfo.rPrice != null){
						if(productInfo.promoPriceUseFlag == "Y" && productInfo.rPromoPrice != null) {
							price = productInfo.rPromoPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ",")+"."+productInfo.rPromoPriceCent;
							_target.querySelector('.product-selling-price .price .number').innerHTML = price;
							$(_target).find('.product-selling-price .price').addClass("active");
							$(_target).find('.product-selling-price .retailer').removeClass("active");
						}else {
							price = productInfo.rPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ",")+"."+productInfo.rPriceCent;
							_target.querySelector('.product-selling-price .price .number').innerHTML = price;
							$(_target).find('.product-selling-price .price').addClass("active");
							$(_target).find('.product-selling-price .retailer').removeClass("active");
						}
					}else {
						$(_target).find('.product-selling-price .price').removeClass("active");
						$(_target).find('.product-selling-price .retailer').removeClass("active");
					}
					_target.querySelector('.product-name').innerHTML = productInfo.userFriendlyName;

					// button controll
					var template = $templateBase.clone().html(),
						$template = null;
					if(productInfo.bizType.toUpperCase() == "B2B") {
						if(productInfo.inquiryToBuyFlag.toUpperCase() == "Y") {
							$template = $(template).filter('*[data-key="inquiryToBuyFlag"]');
							$template.href = productInfo.inquiryToBuyUrl;
						}else if(productInfo.findTheDealerFlag.toUpperCase() == "Y") {
							$template = $(template).filter('*[data-key="findTheDealerFlag"]');
							$template.href = productInfo.findTheDealerUrl;
						}
					}else {
						if(productInfo.addToCartFlag.toUpperCase() == "Y") {
							$template = $(template).filter('*[data-key="addToCartFlag"]');
							//$template.href = productInfo.addToCartUrl;
						}else if(productInfo.whereToBuyFlag.toUpperCase() == "Y") {
							$template = $(template).filter('*[data-key="whereToBuyFlag"]');
							$template.href = productInfo.whereToBuyUrl;
						}
					}

					if($template != null) {
						template = $template.get(0).outerHTML;
					}else {
						template = '';
					}
					template = xssfilter(template, true);
					$(_target).find('.extra-menu').remove();
					$(_target).find('.extra-area').append(template);
				}
			});
		};

		p.scrollPosCheck = function(condition){
			if(condition) {
				$this.addClass("sticky-active");
			} else {
				$this.removeClass("sticky-active");
			}
		};

		p.dropMenu = function(condition){
			if(condition) {
				$tabMenuList.removeClass("open");
				$btnDropMenu.removeClass("open");
				$dimedLayer.removeClass("active");
				/* PJTWAUS-1 20191206 add */
				//$btnDropMenu.attr('aria-expanded', false); /* LGEUS-519 삭제 */
				/*// PJTWAUS-1 20191206 add */
			} else {
				$tabMenuList.addClass("open");
				$btnDropMenu.addClass("open");
				$dimedLayer.addClass("active");
				/* PJTWAUS-1 20191206 add */
				//$btnDropMenu.attr('aria-expanded', true); /* LGEUS-519 삭제 */
				/*// PJTWAUS-1 20191206 add */
				$tabMenuList.children().first().find(".linker").focus();				
			}
		};
		p.dimedException = function(condition){
			if(condition){
				$dimedLayer.removeClass("active");
			}
		};

		p.resizeReset = function(e) {
			if (e.matches) {
				// reset desktop layout
				$tabMenuList.removeClass("open");
				$btnDropMenu.removeClass("open");
				$dimedLayer.removeClass("active");
			} else {
				// clear mobile process
			}
		};
	
		p.scrollAutoFocusing = function(top){
			var onIdx = 0;
			for (var i = 0; i < $linkers.length; i++) {
				var linkerTarget = $linkers.eq(i).get(0).getAttribute('href');
				if($(linkerTarget).length>0) {var partTop = $(linkerTarget).offset().top - $this.outerHeight() - 50,
					hasPadding = ["#pdp_review", "#pdp_spec"];

					if(hasPadding.indexOf(linkerTarget) >= 0) {
						partTop = partTop - 50;
					}

					if(partTop <= top) {
						onIdx = i;
					}
				}
				
			}
			//LGEGMO-5525 add
			$linkers.attr('aria-current', false);
			$linkers.eq(onIdx).attr('aria-current', true);
			//LGEGMO-5525 add
			$linkers.eq(onIdx).parent().addClass('active').siblings().removeClass('active');
			
		};
		p.init();
	};
	tab_sticky();
});
